import type { IconData } from '@stacksjs/iconify-core'

export const shoppingFurniture: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 9a2 2 0 1 0-2 2v5h12v-5a2 2 0 1 0-2-2v2H4z\"/><path fill=\"currentColor\" d=\"M5.5 9a3.5 3.5 0 0 0-3.48-3.5a6 6 0 0 1 11.96 0A3.5 3.5 0 0 0 10.5 9v.5h-5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingFurniture
